import type { TAllPages, TPathsObj } from "@hsr/types";

export const FIX_PATH_USERMANAGEMENT = "/userManagement";
export const FIX_PATH_ACCOUNT = "/users";
export const FIX_PATH_PRODUCT = "/product";
export const FIX_PATH_PRODUCTLIST = "/productlist";
export const FIX_PATH_CARTMANAGER = "/multiplecarts";
export const FIX_PATH_PROFILE = "/profile";
export const FIX_PATH_WISHLIST = "/wishlist";
export const FIX_PATH_COMFIRMATION = "/orders/confirmation";
export const FIX_PATH_CHECKOUT = "/checkout";
export const FIX_PATH_PASSWORDRESET = "/reset-password";

// make some dynamic paths available as "paths" from authContext
export const initialPathsMap: TPathsObj = {
  PATH_CART: "/shoppingcart",
  PATH_ORDERS: "/orders",
  PATH_CONTACT: "/contact",
  PATH_PRIVACY: "/cookies",
  PATH_PRICEINFO: "/shipping_costs",
  PATH_TERMS: "/terms_of_use",
  PATH_SIGNUP: "/register",
  PATH_PAYMENTMETHODS: "/"
};

export const extractPathsFromPages = (allPages: TAllPages[]) => {
  const arr = initialPathsMap;

  // add slugs from pages api
  const CART_SLUG = allPages?.find((page) => page.template === "Cart")?.link;
  const ORDERS_SLUG = allPages?.find(
    (page) => page.template === "Orders Page"
  )?.link;
  const CONTACT_SLUG = allPages?.find(
    (page) => page.template === "Contact Page"
  )?.link;
  const PRIVACY_SLUG = allPages?.find(
    (page) => page.template === "Privacy Page"
  )?.link;
  const TERMS_SLUG = allPages?.find(
    (page) => page.template === "Terms Page"
  )?.link;
  const PRICEINFO_SLUG = allPages?.find(
    (page) => page.template === "Shippingcosts Page"
  )?.link;
  const SIGNUP_SLUG = allPages?.find(
    (page) => page.template === "Sign Up Page"
  )?.link;
  const PAYMENTMETHOD_SLUG = allPages?.find(
    (page) => page.template === "Payment Methods Fragment"
  )?.link;

  if (CART_SLUG) arr.PATH_CART = CART_SLUG.toLowerCase();
  if (ORDERS_SLUG) arr.PATH_ORDERS = ORDERS_SLUG.toLowerCase();
  if (CONTACT_SLUG) arr.PATH_CONTACT = CONTACT_SLUG.toLowerCase();
  if (PRICEINFO_SLUG) arr.PATH_PRICEINFO = PRICEINFO_SLUG.toLowerCase();
  if (PRIVACY_SLUG) arr.PATH_PRIVACY = PRIVACY_SLUG.toLowerCase();
  if (TERMS_SLUG) arr.PATH_TERMS = TERMS_SLUG.toLowerCase();
  if (SIGNUP_SLUG) arr.PATH_SIGNUP = SIGNUP_SLUG.toLowerCase();
  if (PAYMENTMETHOD_SLUG)
    arr.PAYMENTMETHOD_SLUG = PAYMENTMETHOD_SLUG.toLowerCase();

  return arr;
};
